import React from "react";
import {MyContextProvider} from "./src/context/MyContext";

export const wrapRootElement = ({element}) => {
	// Здесь вы можете определить пропсы, которые хотите передать
	const someProp = "Hello, World!";
	
	const originalWarn = console.error;
	
	console.error = (...args) => {
		if (
			typeof args[0] === "string" &&
			args[0].includes("defaultProps will be removed") &&
			args[0].includes("LikeInline")
		) {
			return; // игнорируем
		}
		originalWarn(...args);
	};
	
	return (
		<MyContextProvider someProp={someProp}>
			{element}
		</MyContextProvider>
	);
};